<template>
    <v-container fluid>
        <v-toolbar flat color="white">
            <template>
                <v-toolbar-title>Approvals</v-toolbar-title>
                <v-spacer></v-spacer>
            </template>
        </v-toolbar>
        <v-divider class="my-0 mx-6"></v-divider>
    </v-container>
</template>

<script>
export default {
    name: "ApprovalHeader"
};
</script>

<style scoped>
</style>